import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity11 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_11;
}

export default GravelRoadTileEntity11;
